<template>
  <div class="card">
    <div class="card-body">
      <div class="section-title">Invitation Count</div>
      <div class="row g-2">
        <div class="col-4">
          <div class="stat-pill bg-blue">
            <div class="stat-number">{{ stats.total || 0 }}</div>
            <div class="stat-label">Total</div>
          </div>
        </div>
        <div class="col-4">
          <div class="stat-pill bg-amber">
            <div class="stat-number">{{ stats.sent || 0 }}</div>
            <div class="stat-label">Sent</div>
          </div>
        </div>
        <div class="col-4">
          <div class="stat-pill bg-purple">
            <div class="stat-number">{{ stats.pending || 0 }}</div>
            <div class="stat-label">Pending</div>
          </div>
        </div>
      </div>

      <hr />

      <div class="section-title">RSVP Status</div>
      <div class="row g-2">
        <div class="col-6 mb-3">
          <div class="stat-pill bg-green">
            <div class="stat-number">{{ stats.yes || 0 }}</div>
            <div class="stat-label">Yes</div>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="stat-pill bg-orange">
            <div class="stat-number">{{ stats.maybe || 0 }}</div>
            <div class="stat-label">Maybe</div>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="stat-pill bg-red">
            <div class="stat-number">{{ stats.no || 0 }}</div>
            <div class="stat-label">No</div>
          </div>
        </div>
        <div class="col-6 mb-3">
          <div class="stat-pill bg-deepblue">
            <div class="stat-number">{{ stats.noresponse || 0 }}</div>
            <div class="stat-label">No Response</div>
          </div>
        </div>
      </div>

      <hr />

      <div class="section-title">How many are coming?</div>
      <div class="row">
        <div class="col">
          <div class="card soft shadow-sm">
            <div class="card-header fw-600 text-muted">Confirmed</div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col">
                  <div class="big-num">{{ stats.yesAdult || 0 }}</div>
                  <div class="muted-12">Adults</div>
                </div>
                <div class="col">
                  <div class="big-num">{{ stats.yesChild || 0 }}</div>
                  <div class="muted-12">Children</div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col">
          <div class="card soft shadow-sm">
            <div class="card-header fw-600 text-muted">Maybe</div>
            <div class="card-body">
              <div class="row text-center">
                <div class="col">
                  <div class="big-num">{{ stats.maybeAdult || 0 }}</div>
                  <div class="muted-12">Adults</div>
                </div>
                <div class="col">
                  <div class="big-num">{{ stats.maybeChild || 0 }}</div>
                  <div class="muted-12">Children</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div><!-- /headcount -->
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'EventAnalytics',
  props: {
    stats: { type: Object, default: () => ({}) }
  }
})
</script>

<style scoped>
.section-title{font-weight:600;margin-bottom:.5rem}
.stat-pill{padding:.6rem;border-radius:10px;color:#fff;text-align:center}
.bg-blue{background:#4f46e5}.bg-amber{background:#f59e0b}.bg-purple{background:#7c3aed}
.bg-green{background:#16a34a}.bg-orange{background:#fb923c}.bg-red{background:#ef4444}.bg-deepblue{background:#2563eb}
.stat-number{font-weight:700;font-size:1.1rem}
.stat-label{font-size:.8rem;opacity:.9}
.big-num{font-weight:700;font-size:1.25rem}
.muted-12{font-size:.8rem;color:#6b7280}
</style>
